export default "__VITE_ASSET__d80b3536__"